import axios from 'axios';
import { IAppConfig } from '../../../shared/models/configs/IAppConfig';

const baseUrl = `${fdot.process.env.BACKEND_SERVER_HOST}/api/config`;

export const getConfig = async (): Promise<IAppConfig> => {
    const response = await axios.get(baseUrl);
    return response.data;
};